import { render, staticRenderFns } from "./trade_flow_list.vue?vue&type=template&id=1f753db6&scoped=true"
import script from "./trade_flow_list.vue?vue&type=script&lang=js"
export * from "./trade_flow_list.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/financial-tools.scss?vue&type=style&index=0&id=1f753db6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f753db6",
  null
  
)

export default component.exports